import React from "react";
import { Tree, Tag } from "antd";
import { TreeProps } from "antd/lib/tree";
import { Loader } from "Components/General/Loader";
import { stringSort } from "utils/defaultSort";
const TreeNode = Tree.TreeNode;

const FilesBadge = ({ total, direct }) => (
  <Tag style={{ marginLeft: 4, position: "relative", top: -2 }}>
    {direct}
    {total ? `/${total}` : ""}
  </Tag>
);

interface AsyncTreeProps {
  data: API_TreeElement | Array<API_TreeElement>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  loadData?: (nodeProps: any) => PromiseLike<any>; // Makes fetch request
  treeProps?: TreeProps; // See Ant Tree component
  handleSelect?: (id: number | string) => void; // Select Tree item trigger
  selectProp?: string | string[]; // Property passed in handleSelect function
  hideFilesBadge?: boolean;
}

export class AsyncTree extends React.Component<AsyncTreeProps, {}> {
  onSelect = (info, e) => {
    const { selectProp } = this.props;
    if (this.props.handleSelect) {
      const selectedProps = Array.isArray(selectProp)
        ? selectProp.map((prop) => e.node.props[prop])
        : e.node.props[selectProp];

      this.props.handleSelect(selectedProps);
    }
  };

  onLoadData = async (props) => {
    if (props.subfolders) {
      return;
    }
    if (this.props.loadData) {
      await this.props.loadData(props.key);
    }
  };

  render() {
    const { data, hideFilesBadge } = this.props;
    const loop = (nodesData: API_TreeElement | Array<API_TreeElement>) => {
      if (Array.isArray(nodesData)) {
        return nodesData
          .sort((a, b) => stringSort(a, b, "name"))
          .map((item) => {
            let title;
            if (hideFilesBadge) {
              title = <>{item.name}</>;
            } else {
              title =
                item.directFiles || item.totalFiles ? (
                  <>
                    {item.name} <FilesBadge direct={item.directFiles ? item.directFiles : 0} total={item.totalFiles} />
                  </>
                ) : (
                  item.name
                );
            }
            if (item.children) {
              return (
                <TreeNode active={false} title={title} {...item} id={`${item.id}`} key={`${item.id}`}>
                  {loop(item.subfolders || [])}
                </TreeNode>
              );
            }

            return (
              <TreeNode
                active={false}
                title={title}
                {...item}
                id={`${item.id}`}
                key={`${item.id}`}
                isLeaf={!item.children}
              />
            );
          });
      } else if (typeof nodesData === "object") {
        return (
          <TreeNode
            active={false}
            title={
              <>
                {nodesData.name}{" "}
                <FilesBadge direct={nodesData.directFiles ? nodesData.directFiles : 0} total={nodesData.totalFiles} />
              </>
            }
            key={`root`}
          >
            {loop(nodesData.subfolders)}
          </TreeNode>
        );
      } else {
        return null;
      }
    };

    const treeNodes = loop(data);
    return this.props.data ? (
      <Tree
        onSelect={this.onSelect}
        loadData={this.onLoadData}
        defaultExpandedKeys={[`root`]}
        {...this.props.treeProps}
        className="folder-icons"
      >
        {treeNodes}
      </Tree>
    ) : (
      <Loader />
    );
  }
}
